export default "__VITE_ASSET__CI71iuX$__"